import React, { useRef, useState, useEffect, useLayoutEffect } from "react";
import "./style.css";
import styleForm from "../../pages/WorkFlow/Requests/Requests.module.scss"
import { Container, Form, InputGroup, Row, Col, ToggleButton, Button, ButtonGroup, Dropdown, Tooltip, OverlayTrigger, InputGroup as RBInputGroup, Modal } from 'react-bootstrap';
import Select from 'react-select'
import ListGroup from 'react-bootstrap/ListGroup';
import { TODIS_BTN_PRIMARY } from '../Buttons'
import { Field, useField, useFormikContext } from "formik";
import { BsSearch, BsPlusLg } from "react-icons/bs";
import { MdGrid3X3, MdCircle, MdDelete } from "react-icons/md";
import DatePicker from "react-datepicker";
import DatePickerYear from "react-multi-date-picker"
import dateFormat, { masks } from "dateformat";
import "react-datepicker/dist/react-datepicker.css";
import transition from "react-element-popper/animations/transition"
import opacity from "react-element-popper/animations/opacity"
import Table from "react-bootstrap/Table";
import { DataCollectionService } from "../../HttpService/DataCollectionService";


const statusClass = (statusId) => {
    switch (statusId) {
        case 0:
            return "#F4D35A"
            break;
        case 1:
            return "#3db73d"
            break;
        case 2:
            return "#ff0000"
            break;
        case 3:
            return "#3db73d"
            break;
        default:
            break;
    }
}

// Helper for dynamic capacity label
const getCapacityLabel = (fuelType) => {
    switch (fuelType) {
        case "Electricity light":
        case "Electricity heavy":
            return "Capacity (kW)";
        case "Hydrogen":
            return "Capacity (kg/day)";
        case "Liquified methane":
            return "Capacity (m³)";
        default:
            return "Capacity";
    }
};

// Table type

const TODIS_FORM_FIELD_TABLE = ({
   columns,
    data = [],
    label,
    refreshData,
    apiBase,
    extraFields = [],
    defaultValues = {},
    fetchParams = {},
    fuelTypeOptions = [],
    showFuelType = false
}) => {
   // --- STATE ---
       const [showAddModal, setShowAddModal] = useState(false);
       const [showEditModal, setShowEditModal] = useState(false);
       const [addError, setAddError] = useState("");
       const [editError, setEditError] = useState("");
       const [isAdding, setIsAdding] = useState(false);
       const [isEditing, setIsEditing] = useState(false);
       const [deleteError, setDeleteError] = useState("");


    // For add/edit forms
        const [formState, setFormState] = useState(defaultValues);

    // --- HANDLERS ---
    const openAddModal = () => {
        setFormState(defaultValues);
        setAddError("");
        setShowAddModal(true);
    };

    const openEditModal = (row) => {
        setFormState({ ...row });
        setEditError("");
        setShowEditModal(true);
    };

    // --- DELETE ---
    const handleDelete = async (config, id, fetchParams) => {
        try {
            setDeleteError("");
            const service = new DataCollectionService(`${config.apiBase}/delete`);
            const res = await service.deleteById(id);
            if (res?.status >= 200 && res?.status < 300) {
                const updatedFetchParams = {
                    ...fetchParams,
                    fuelType: config.defaultValues?.fuelType || fetchParams?.fuelType
                };
                await refreshData?.(config, updatedFetchParams);
                setDeleteError("");

            } else {
                console.error(res?.data?.message || "Error while deleting. Please try again.");
                setDeleteError(res?.data?.message || "Error while deleting. Please try again.");
            }
        } catch (err) {
            console.error("❌ Error while deleting:", err);
            setDeleteError(err.response?.data?.message || "Error while deleting. Please try again.");
        }
    };

    // --- ADD ---

    const handleAddSubmit = async (config) => {
        try {
            setIsAdding(true);
            setAddError("");

            const requiredFields = [
                ...config.columns.map(col => col.key),
                ...config.extraFields.map(field => field.name)
            ];

            const emptyField = requiredFields.find(field => {
                const value = formState[field];
                return value === undefined || value === null || value.toString().trim() === "";
            });

            if (emptyField) {
                setAddError("Please fill out all fields.");
                setIsAdding(false);
                return;
            }

            const body = {
                ...fetchParams,
                ...formState,
            };

            const service = new DataCollectionService(`${config.apiBase}/add`);
            const res = await service.createform2(body);

            if (res?.status >= 200 && res?.status < 300) {
                await refreshData?.(config, fetchParams);
                setShowAddModal(false);
                setFormState(config.defaultValues);
            } else {
                //setAddError(res?.data?.message || res?.response?.data?.message || "Error while adding. Please try again.");
                const errorMessage = res?.data?.message || res?.response?.data?.message;
                if (errorMessage && errorMessage !== "Malformed JSON request") setAddError(errorMessage);
                else setAddError("Error while adding. Please try again.");
            }
            
        } catch (error) {
            console.error("❌ Axios greška:", error);
            setAddError(error.response?.data?.message || "Error while adding. Please try again.");
        } finally {
            setIsAdding(false);
        }
    };

    const handleEditSubmit = async (config) => {
        try {
            setIsEditing(true);
            setEditError("");

            const requiredFields = [
                ...config.columns.map(col => col.key),
                ...config.extraFields.map(field => field.name)
            ];

            const emptyField = requiredFields.find(field => {
                const value = formState[field];
                return value === undefined || value === null || value.toString().trim() === "";
            });

            if (emptyField) {
                setEditError("Please fill out all fields.");
                setIsEditing(false);
                return;
            }

            const body = { ...fetchParams, ...formState };
            const service = new DataCollectionService(`${config.apiBase}/edit`);
            const res = await service.editRecord(body);
            
            if (res?.status >= 200 && res?.status < 300) {
                // refresh za ovu tabelu
                await refreshData?.(config, fetchParams);

                setShowEditModal(false);
                setFormState(defaultValues);
            } else {
                //setEditError(res?.data?.message || res?.response?.data?.message || "Error while editing. Please try again.");
                const errorMessage = res?.data?.message || res?.response?.data?.message;
                if (errorMessage && errorMessage !== "Malformed JSON request") setEditError(errorMessage);
                else setEditError("Error while editing. Please try again.");
            }
        } catch (err) {
            console.error("❌ Axios greška:", err);
            setEditError(err.response?.data?.message || "Error while editing. Please try again.");
        } finally {
            setIsEditing(false);
        }
    };


    // --- RENDER ---
    return (
        <Form.Group className="mb-3" controlId={label}>
            <Form.Label style={{ ...input_org_styles_lable, marginBottom: "1.5rem"}}>{label}</Form.Label>
            <Button variant="secondary" size="sm" onClick={openAddModal} className="mb-2 float-end" style={{ marginTop: "0.5rem" }}>
                Add
            </Button>
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        {columns.map((col, idx) => <th key={idx}>{col.header}</th>)}
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {data.length > 0 ? data.map((row, idx) => (
                        <tr key={idx}>
                            {columns.map((col, cidx) => (
                                <td key={cidx}>{row[col.key]}</td>
                            ))}
                            <td>
                                <Button size="sm" variant="secondary" className="me-2" onClick={() => openEditModal(row)}>Edit</Button>
                                <Button size="sm" variant="outline-secondary" onClick={() => handleDelete({ apiBase, defaultValues }, row.id, fetchParams)}>Delete</Button>
                            </td>
                        </tr>
                    )) : (
                        <tr>
                            <td colSpan={columns.length + 1} className="text-center text-muted">No data available</td>
                        </tr>
                    )}
                </tbody>
            </Table>
            
            {deleteError && (<div className="alert alert-danger mt-2">{deleteError}</div>)}


            {/* Add Modal */}
            <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Add New</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {columns.map((col, idx) => (
                        <Form.Group className="mb-3" key={idx}>
                            <Form.Label>{col.header}</Form.Label>
                            <Form.Control
                                type={col.type || "text"}
                                value={formState[col.key] || ""}
                                onChange={e => setFormState({ ...formState, [col.key]: e.target.value })}
                            />
                        </Form.Group>
                    ))}
                    {extraFields.map((field, idx) => (
                        <Form.Group className="mb-3" key={idx}>
                            <Form.Label>
                                {field.name === "capacity" && showFuelType
                                    ? getCapacityLabel(formState.fuelType)
                                    : field.label}
                            </Form.Label>
                            {field.type === "select" ? (
                                <Form.Select
                                    value={formState[field.name] || ""}
                                    onChange={e => setFormState({ ...formState, [field.name]: e.target.value })}
                                >
                                    <option value="">Select</option>
                                    {field.options.map(opt => (
                                        <option key={opt} value={opt}>{opt}</option>
                                    ))}
                                </Form.Select>
                            ) : (
                                <Form.Control
                                    type={field.type}
                                    value={formState[field.name] || ""}
                                    onChange={e => setFormState({ ...formState, [field.name]: e.target.value })}
                                />
                            )}
                        </Form.Group>
                    ))}
                    {addError && <div className="alert alert-danger mt-2">{addError}</div>}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowAddModal(false)}>Cancel</Button>
                    <Button variant="primary" onClick={() => handleAddSubmit({ apiBase, columns, extraFields, defaultValues })} disabled={isAdding}>
                        {isAdding ? "Adding..." : "Add"}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Edit Modal */}
            <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {columns.map((col, idx) => (
                        <Form.Group className="mb-3" key={idx}>
                            <Form.Label>{col.header}</Form.Label>
                            <Form.Control
                                type={col.type || "text"}
                                value={formState[col.key] || ""}
                                onChange={e => setFormState({ ...formState, [col.key]: e.target.value })}
                            />
                        </Form.Group>
                    ))}
                    {extraFields.map((field, idx) => (
                        <Form.Group className="mb-3" key={idx}>
                            <Form.Label>
                                {field.name === "capacity" && showFuelType
                                    ? getCapacityLabel(formState.fuelType)
                                    : field.label}
                            </Form.Label>
                            {field.type === "select" ? (
                                <Form.Select
                                    value={formState[field.name] || ""}
                                    onChange={e => setFormState({ ...formState, [field.name]: e.target.value })}
                                >
                                    <option value="">Select</option>
                                    {field.options.map(opt => (
                                        <option key={opt} value={opt}>{opt}</option>
                                    ))}
                                </Form.Select>
                            ) : (
                                <Form.Control
                                    type={field.type}
                                    value={formState[field.name] || ""}
                                    onChange={e => setFormState({ ...formState, [field.name]: e.target.value })}
                                />
                            )}
                        </Form.Group>
                    ))}
                    {editError && <div className="alert alert-danger mt-2">{editError}</div>}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEditModal(false)}>Cancel</Button>
                    <Button variant="primary" onClick={() =>
                            handleEditSubmit({ apiBase, columns, extraFields, defaultValues })
                        } disabled={isEditing}>
                        {isEditing ? "Saving..." : "Save"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </Form.Group>
    );
};


//Text type
const TODIS_FORM_TEXT = (props) => {
    return (
        <Form.Control type="text" placeholder={props.placeholder} style={text_styles} className="todis-forms" />
    )
}

const TODIS_FORM_FILE = (props) => {
    return (
        <Form.Group className="mb-3" controlId={props.id}>
            <Form.Label style={input_org_styles_lable}>{props.label}</Form.Label>
            <Form.Control type="file" htmlFor={props.id} placeholder={props.placeholder} style={input_org_styles} as={props.type} className="todis-forms" onChange={props.filechange} />
        </Form.Group>
    )
}

//Text type
const TODIS_FORM_PASS = (props) => {
    return (
        <Form.Control type="password" placeholder={props.placeholder} style={text_styles} className="todis-forms" />
    )
}


const TODIS_FORM_ORG = (props) => {
    return (
        <Form.Group className="mb-3" controlId={props.id}>
            <Form.Label style={input_org_styles_lable}>{props.label}</Form.Label>
            <Form.Control id={props.id} type={props.type} placeholder={props.placeholder} style={input_org_styles} />
            {/* <Form.Text className="text-muted">
                We'll never share your email with anyone else.
            </Form.Text> */}
        </Form.Group>
    )
}

const TODIS_FORM_FIELD_TEXT = (props) => {
    return (
        <Form.Group className="mb-3" controlId={props.id}>
            <Form.Label style={input_org_styles_lable}>{props.label}</Form.Label>
            <Field type="text" id={props.id} name={props.name} className="form-control" placeholder={props.placeholder} style={input_org_styles} />
        </Form.Group>)
}

const TODIS_FORM_FIELD_PASS = (props) => {
    return <Form.Group className="mb-3" controlId={props.id}>
        <Form.Label style={input_org_styles_lable}>{props.label}</Form.Label>
        <Field type="password" id={props.id} name={props.name} className="form-control" placeholder={props.placeholder} style={input_org_styles} />
    </Form.Group>
}

const TODIS_FORM_DSC = (props) => {
    return <Form.Group className="mb-3" controlId={props.id}>
        <Form.Label style={input_org_styles_lable}>{props.label}</Form.Label>
        <Field as="textarea" id={props.id} name={props.name} style={{ ...input_desc_styles, ...props.style }} className="form-control" disabled={props.disabled} />
    </Form.Group>

}

const TODIS_FORM_FIELD = (props) => {
    const [field, meta] = useField(props);
    const textAreaRef = useRef(null);

    useLayoutEffect(() => {
        adjustHeight();
    }, [props.holder, field.value]);

    const adjustHeight = () => {
        if (textAreaRef.current) {
            textAreaRef.current.style.height = 'auto'; // Reset height to auto
            textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`; // Set to scrollHeight
        }
    };

    const handleInputChange = (e) => {
        field.onChange(e);
        adjustHeight();
        if (props.onChange) {
            props.onChange(e);
        }
    };

    return (
        <Form.Group className="mb-3" controlId={props.id}>
            <Form.Label style={input_org_styles_lable}>{props.label}</Form.Label>
            <Field
                {...field}
                as="textarea"
                placeholder={props.holder}
                disabled={props.name.split('.').pop().startsWith('c_') || props.disabled}
                autoComplete="off"
                style={{
                    ...input_org_styles,
                    height: 'auto',
                    minHeight: '70px', // Set a reasonable initial height
                    overflow: 'hidden',
                    resize: 'none'
                }}
                onInput={handleInputChange}
                innerRef={textAreaRef}
                onBlur={(e) => {
                    adjustHeight(); // Adjust height on blur to handle cases where text is pasted
                    if (props.onBlur) {
                        props.onBlur(e);
                    }
                }}
            />
            {meta.touched && meta.error ? (
                <div className="error">{meta.error}</div>
            ) : null}
        </Form.Group>
    );
};


const TODIS_FORM_FIELD_NUMBER = (props) => {
    const [field, meta] = useField(props);    

    return (
        <Form.Group className="mb-3" controlId={props.id}>
            <Form.Label style={input_org_styles_lable}>{props.label}</Form.Label>
            <Field
                {...field}
                as="number"
                placeholder={props.holder}
                autoComplete="off"
                style={{
                    ...input_org_styles,
                    height: 'auto',
                    minHeight: '70px', // Set a reasonable initial height
                    overflow: 'hidden',
                    resize: 'none'
                }}
            />
            {meta.touched && meta.error ? (
                <div className="error">{meta.error}</div>
            ) : null}
        </Form.Group>
    );
};

const TODIS_FORM_FIELD_OTHER = (props) => {
    const [field, meta, helpers] = useField(props);
    const textAreaRef = useRef(null);

    useEffect(() => {
        adjustHeight();
    }, [props.holder]);

    const adjustHeight = () => {
        if (textAreaRef.current) {
            textAreaRef.current.style.height = 'auto'; // Reset height to auto
            textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`; // Set to scrollHeight
        }
    };

    const handleInputChange = (e) => {
        adjustHeight();
        helpers.setValue(e.target.value); // Set Formik's value
    };

    return (
        <Form.Group className="mb-3" controlId={props.id}>
            <Form.Label style={input_org_styles_lable}>{props.label}</Form.Label>
            <Field
                {...field}
                as="textarea"
                value={props.field.value || ''}  // Use value instead of placeholder
                disabled={props.name.split('.').pop().startsWith('c_') || props.disabled}
                autoComplete="off"
                style={{
                    ...input_org_styles,
                    height: 'auto',
                    minHeight: '50px', // Set a reasonable initial height
                    overflow: 'hidden',
                    resize: 'none'
                }}
                onChange={handleInputChange}
                innerRef={textAreaRef}
            />
            {meta.touched && meta.error ? (
                <div className="error">{meta.error}</div>
            ) : null}
        </Form.Group>
    );
};

const TODIS_FORM_FIELD_MOD = (props) => {
    return (
        <Form.Group className="mb-3" controlId={props.id}>
            <Form.Label style={input_org_styles_lable}>{props.label}</Form.Label>
            <Field
                id={props.id}
                name={props.name}
                style={input_org_styles}
                as={props.type}
                placeholder={props.holder}
                disabled={props.disabled}
                autoComplete="off"
                value={props.disabled ? props.value : props.value}
            />
        </Form.Group>
    );
};

const TODIS_FORM_FIELD_ROUTE = (props) => {
    // Lógica para asignar valores a InternationalRouteID y NationalRouteID
    const finalInternationalRouteID = props.internationalRouteId !== null ? props.internationalRouteId : props.routeId;
    const finalNationalRouteID = props.nationalRouteId !== null ? props.nationalRouteId : props.routeId;

    // Obtiene el valor correspondiente según la restricción
    const fieldValue =
        props.name === "nationalRouteId" ? finalNationalRouteID :
            props.name === "internationalRouteId" ? finalInternationalRouteID :
                props.routeId;

    return (
        <Form.Group className="mb-3" controlId={props.id}>
            <Form.Label style={input_org_styles_lable}>{props.label}</Form.Label>
            <Field
                id={props.id}
                name={props.name}
                style={input_org_styles}
                as={props.type}
                placeholder={props.holder}
                disabled={props.disabled}
                autoComplete="off"
                value={fieldValue}
                onChange={props.onChange}  // Añadí esto por si necesitas manejar cambios
            />
        </Form.Group>
    );
};

const TODIS_FORM_FIELD_INFRA = (props) => {
    const isLengthField = props.name.includes("lengthTunnels");
    const isTunnelsZero = props.name.includes("tunnelsDirA") ? props.tunnelsDirA === 0 : props.tunnelsDirB === 0;
    const shouldDisable = isTunnelsZero && isLengthField; // Deshabilitar solo si es un campo de longitud y los túneles son 0

    return (
        <Form.Group className="mb-3" controlId={props.id}>
            <Form.Label style={input_org_styles_lable}>{props.label}</Form.Label>
            <Field
                id={props.id}
                name={props.name}
                style={input_org_styles}
                as={props.type}
                placeholder={props.holder}
                disabled={shouldDisable || props.disabled}
                autoComplete="off"
                value={shouldDisable ? "" : props.value}
                onChange={(e) => {
                    if (shouldDisable) {
                        e.preventDefault();
                    } else {
                        props.onChange(e);
                    }
                }}
            />
        </Form.Group>
    );
};


const TODIS_FORM_FIELD_DROP = ({ id, name, notLabel = true, label, type, holder, options, disabled, val, ...props }) => {
    return (
        <Form.Group className="mb-3" controlId={id}>
            {notLabel && <Form.Label className="form-label" style={input_org_styles_lable}>{label}</Form.Label>}
            {disabled ? (
                <TODIS_FORM_FIELD_MOD id={id} name={name} type={type} placeholder={holder} value={val} disabled={disabled} />
            ) : (
                <Field
                    id={id}
                    name={name}
                    as="select"
                    style={input_org_styles}
                    placeholder={holder}
                    disabled={disabled}
                    autoComplete="off"
                >
                    <option value="" disabled hidden>{props.empty || ""}</option>
                    <option value="Level 1">Level 1</option>
                    <option value="Level 2">Level 2</option>
                    <option value="Level 3">Level 3</option>
                    <option value="N/A">N/A</option>
                </Field>
            )}
        </Form.Group>
    );
}

const TODIS_FORM_FIELD_TEXT_FORM = (props) => {
    return <Form.Group className="mb-3" controlId={props.id}>
        <Form.Label style={label_style}>{props.label}</Form.Label>
        <span style={{ fontWeight: "600" }} >{props.values}</span>
    </Form.Group>
}


const TODIS_FORM_FIELD_YES_NO = ({ empty = "", disabled, ...props }) => {
    const inputStyles = {
        ...input_org_styles,
        backgroundColor: disabled ? '#e9ecef' : '', // Cambia el fondo a gris si está deshabilitado
        color: disabled ? '#6c757d' : '', // Cambia el color del texto a gris oscuro si está deshabilitado
        appearance: disabled ? 'none' : '', // Esconde la flecha si está deshabilitado
        MozAppearance: disabled ? 'none' : '', // Firefox
        WebkitAppearance: disabled ? 'none' : '', // Safari y Chrome
    };

    return (
        <Form.Group className="mb-3" controlId={props.id}>
            <Form.Label style={input_org_styles_lable}>{props.label}</Form.Label>
            <Field
                id={props.id}
                name={props.name}
                style={inputStyles}
                as="select"
                placeholder={props.holder}
                disabled={disabled}
            >
                <option value="">{empty}</option>
                <option value={true}>Yes</option>
                <option value={false}>No</option>
            </Field>
        </Form.Group>
    );
};

/* const TODIS_FORM_FIELD_YES_NO = ({empty = "", ...props}) => {
    return <Form.Group className="mb-3" controlId={props.id}>
        <Form.Label  style={input_org_styles_lable}>{props.label}</Form.Label>
        <Field id={props.id} name={props.name} style={input_org_styles} as="select" placeholder={props.holder} disabled={props.disabled}>
            <option value="">{empty}</option>
            <option value={true}>Yes</option>
            <option value={false}>No</option>
        </Field>
    </Form.Group>
} */

/* const TODIS_FORM_FIELD_YES_NO = ({ empty = "", disabled, ...props }) => {
    const yesNoValue = props.value ? "Yes" : "No";

    if (disabled) {
        return (
            <Form.Group className="mb-3" controlId={props.id}>
                <Form.Label style={input_org_styles_lable}>{props.label}</Form.Label>
                <input
                    id={props.id}
                    name={props.name}
                    style={input_org_styles}
                    value={yesNoValue === "Yes" ? "No" : yesNoValue}
                    placeholder={props.placeholder}
                    disabled={disabled}
                />
            </Form.Group>
        );
    } else {
        return (
            <Form.Group className="mb-3" controlId={props.id}>
                <Form.Label style={input_org_styles_lable}>{props.label}</Form.Label>
                <Field
                    id={props.id}
                    name={props.name}
                    style={input_org_styles}
                    as="select"
                    placeholder={props.placeholder}
                    disabled={disabled}
                >
                    <option value="">{empty}</option>
                    <option value={true}>Yes</option>
                    <option value={false}>No</option>
                </Field>
            </Form.Group>
        );
    }
} */


const TODIS_FORM_FIELD_OPTIONS_WITHOUT_CHANGE = ({ empty, id, name, notLabel = true, label, type, holder, options, disabled, val, onChange }) => {
    return (
        <Form.Group className="mb-3" controlId={id}>
            {notLabel && <Form.Label className="form-label" style={input_org_styles_lable}>{label}</Form.Label>}
            {disabled ? (
                <TODIS_FORM_FIELD_MOD id={id} name={name} type={type} placeholder={holder} value={val} disabled={disabled} />
            ) : (
                <Field
                    id={id}
                    name={name}
                    style={type === "sharing" ? input_ddl_styles : input_org_styles}
                    as="select"
                    placeholder={holder}
                    disabled={disabled}
                    onChange={onChange}
                    value={val}  // Establecer el valor directamente cuando está deshabilitado
                >
                    <option value="">{empty}</option>
                    {options.map((option, index) => (
                        <option key={index} value={option.txtDescription}>
                            {option.txtDescription}
                        </option>
                    ))}
                </Field>
            )}
        </Form.Group>
    );
};

const TODIS_FORM_FIELD_OPTIONS_WITHOUT_CHANGE_1 = ({ id, name, notLabel = true, label, type, holder, options, disabled, val }) => {
    const inputStyles = {
        ...input_org_styles,
        backgroundColor: disabled ? '#e9ecef' : '', // Fondo gris si está deshabilitado
        color: disabled ? '#6c757d' : '', // Color del texto a gris oscuro si está deshabilitado
        appearance: disabled ? 'none' : '', // Esconde la flecha si está deshabilitado
        MozAppearance: disabled ? 'none' : '', // Firefox
        WebkitAppearance: disabled ? 'none' : '', // Safari y Chrome
        pointerEvents: disabled ? 'none' : '', // Deshabilita eventos de ratón si está deshabilitado
    };

    return (
        <Form.Group className="mb-3" controlId={id}>
            {notLabel && <Form.Label className="form-label" style={input_org_styles_lable}>{label}</Form.Label>}

            <Field
                id={id}
                name={name}
                style={inputStyles}
                as="select"
                placeholder={holder}
                disabled={disabled}
            >
                <option value=""></option>
                {options.map((option, index) => (
                    <option key={index} value={option.txtDescription} selected={val === option.txtDescription}>
                        {option.txtDescription}
                    </option>
                ))}
            </Field>
        </Form.Group>
    );
}

const TODIS_FORM_FIELD_OPTIONS_ITS = ({ id, name, notLabel = true, label, type, holder, options, disabled, val, onChange }) => {
    const handleChange = (optionValue, isChecked) => {
        // Manejar el cambio en el checkbox y actualizar el estado
        const updatedValues = isChecked
            ? [...val, optionValue]
            : val.filter(value => value !== optionValue);
        onChange(updatedValues);
    };

    return (
        <Form.Group className="mb-3" controlId={id}>
            {
                notLabel && <Form.Label className="form-label" style={input_org_styles_lable}>{label}</Form.Label>
            }
            {options.map((option, index) => (
                <Form.Check
                    key={index}
                    type="checkbox"
                    id={`${id}-${index}`}
                    label={option.txtDescription}
                    value={option.txtDescription}
                    checked={val ? val.includes(option.idAuxtabledetail) : false}
                    onChange={(e) => handleChange(option.idAuxtabledetail, e.target.checked)}
                    disabled={disabled}
                />
            ))}
        </Form.Group>
    );
};


const TODIS_FORM_FIELD_OPTIONS = ({ id, name, notLabel = true, label, type, holder, options, disabled, val }) => {
    return (
        <Form.Group className="mb-3" controlId={id}>
            {notLabel && <Form.Label className="form-label" style={input_org_styles_lable}>{label}</Form.Label>}
            {disabled ? (
                <TODIS_FORM_FIELD_MOD id={id} name={name} type={type} placeholder={holder} value={val} disabled={disabled} />
            ) : (
                <Field
                    id={id}
                    name={name}
                    style={type === "sharing" ? input_ddl_styles : input_org_styles}
                    as="select"
                    placeholder={holder}
                    disabled={disabled}
                >
                    <option value="N/A">N/A</option>
                    {options.map((option, index) => (
                        <option key={index} value={option.txtDescription} selected={option.txtDescription === val}>
                            {option.txtDescription}
                        </option>
                    ))}
                </Field>
            )}
        </Form.Group>
    );
};


const TODIS_FORM_FIELD_OPTIONS_WITH_CHANGE_MULTIPLE = ({ id, name, notLabel = true, label, type, holder, options, disabled, val }) => {
    return (
        <Form.Group className="mb-3" controlId={id}>
            {notLabel && <Form.Label className="form-label" style={input_org_styles_lable}>{label}</Form.Label>}
            {disabled ? (
                <TODIS_FORM_FIELD id={id} name={name} type={type} holder={holder} disabled={disabled} />
            ) : (
                <Field
                    id={id}
                    name={name}
                    style={type === "sharing" ? input_ddl_styles : input_org_styles}
                    as="select"
                    placeholder={holder}
                    disabled={disabled}
                    multiple  // Agrega la propiedad 'multiple' para permitir múltiples selecciones
                >
                    {options.map((option, index) => (
                        <option key={index} value={option.txtDescription} selected={val.includes(option.txtDescription)}>
                            {option.txtDescription}
                        </option>
                    ))}
                </Field>
            )}
        </Form.Group>
    );
}



const TODIS_FORM_FIELD_OPTIONS_WITHOUT_CHANGE_ID = ({ id, name, notLabel = true, label, type, holder, options, disabled, val }) => {
    return <Form.Group className="mb-3" controlId={id}>
        {
            notLabel && <Form.Label className="form-label" style={input_org_styles_lable}>{label}</Form.Label>
        }
        <Field id={id} name={name} style={type == "sharing" ? input_ddl_styles : input_org_styles} as="select" placeholder={holder} disabled={disabled} >
            <option value="">Select</option>
            {options.map((option, index) => {
                return val == option.idAuxtabledetail ? <option key={index} value={option.idAuxtabledetail} selected>{option.txtDescription}</option> : <option key={index} value={option.idAuxtabledetail}>{option.txtDescription}</option>
            })}
        </Field>
    </Form.Group>
}

const TODIS_FORM_FIELD_OPTIONS_DESC = ({ id, name, notLabel = true, label, type, holder, options, disabled }) => {
    return <Form.Group className="mb-3" controlId={id}>
        {
            notLabel && <Form.Label className="form-label" style={input_org_styles_lable}>{label}</Form.Label>
        }
        <Field id={id} name={name} style={type == "sharing" ? input_ddl_styles : input_org_styles} as="select" placeholder={holder} disabled={disabled}>
            <option value="">Select</option>
            {options.map((option, index) => {
                return <option key={index} value={option.idAuxtabledetail}>{option.txtDescription}</option>
            })}
        </Field>
    </Form.Group>
}
const TODIS_FORM_FIELD_OPTIONS_GDB = ({ id, name, notLabel = true, label, type, holder, options, onchange, placeholder, disabled }) => {
    return <Form.Group className="mb-3" controlId={id}>
        {
            notLabel && <Form.Label className="form-label" style={input_org_styles_lable}>{label}</Form.Label>
        }
        <Field style={input_org_styles} id={id} name={name} onClick={onchange} as="select" placeholder={holder} disabled={disabled}>
            <option value="">Select</option>
            {options && options.map((option, index) => (
                <option key={index} value={option.idAuxtabledetail}>{option.txtDescription}</option>
            ))}
        </Field>
    </Form.Group>
}


const TODIS_FORM_FIELD_OPTIONS_WITH_CHANGE = ({ id, name, notLabel = true, label, type, holder, options, onchange, placeholder, nameValue, nameDesc, disabled }) => {

    return <Form.Group controlId={id}>
        {
            notLabel && <Form.Label className="form-label" style={input_org_styles_lable}>{label}</Form.Label>
        }
        <Field id={id} name={name} onChange={(e) => onchange(e)} style={type == "sharing" ? input_ddl_styles : input_org_styles} as="select" placeholder={holder} disabled={disabled}>
            <option value="">{placeholder}</option>
            {options.map((option, index) => {
                return <option key={index} value={option[nameValue]}>{option[nameDesc]}</option>
            })}
        </Field>
    </Form.Group>
}

const TODIS_FORM_FIELD_OPTIONS_SL = (props) => {
    return <Form.Group controlId={props.id}>
        <select id={props.id} name={props.name} style={input_ddl_styles} placeholder={props.holder}>
            {props.options.map((option, index) => {
                return <option key={index} value={option.idAuxtabledetail}>{option.txtDescription}</option>
            })}
        </select>
    </Form.Group>
};

const TODIS_FORM_FIELD_CHECK = ({ id, label, selectAll, type, disabled }) => {
    return <Form.Check type="checkbox" id={id} className="float-end">
        <Form.Check.Input type="checkbox" style={{ border: type == "sharing" ? "2px solid #FFC61C" : "2px solid #004494" }} onClick={(e) => { selectAll(e) }} disabled={disabled} />
        <Form.Check.Label className="font-monospace fw-bold" style={{ fontSize: "14px" }}>{label}</Form.Check.Label>
    </Form.Check>
}

const TODIS_FORM_FIELD_LIST = (props) => {

    return <Form.Group className="mb-3">
        <Form.Label style={input_org_styles_lable}>{props.label}</Form.Label>
        <Container className={props.type == "added" ? "todis-form-wrapperAdd" : "todis-form-wrapperR"}>
            <Row className="list-Items">
                {
                    props.type != "added" &&
                    <div className="pt-3">
                        <TODIS_FORM_FIELD_CHECK id={`${"selectAll-"}${props.type}`} label="SELECT ALL" selectAll={props.selectAll} />
                    </div>
                }
                <ListGroup className="overflow-auto mt-3" style={{ maxHeight: props.type != "added" ? "480px" : "520px", flexGrow: "1" }}>
                    {props.items.map((itm) => {
                        return (
                            <ListGroup.Item
                                key={`itemSelect${itm.id}`}
                                onClick={props.toggleSelection ? () => props.toggleSelection(itm.id) : () => { }}
                                active={itm.active}
                                className={`${props.type != "added" ? styleForm.dataInfo : styleForm.dataInfoAdd} ${"mt-4"}`}
                            >
                                <Container>
                                    <Row>
                                        <Col lg={props.type != "added" ? 12 : 11}>
                                            <h5 className="fw-bold">{itm.name} in { }</h5>
                                            <Row className="selectable-task">
                                                <Col sm="0">
                                                    <ToggleButton
                                                        className="mx-1"
                                                        type="checkbox"
                                                        size="sm"
                                                        key={`check${itm.id}`}
                                                        checked={itm.active}
                                                        value={itm.id}
                                                        hidden
                                                    ></ToggleButton>
                                                </Col>
                                                <Col lg={1} className="w-auto">
                                                    <span><MdGrid3X3 size="18" color="#004494" /> {itm.id}</span>
                                                </Col>
                                                <Col lg={2} className="w-auto">
                                                    <span style={{ textTransform: "capitalize" }}><MdCircle size="18" className="me-1" color={statusClass(itm.statusID)} /> {itm.status}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        {
                                            props.type == "added" &&
                                            <Col lg={1} className="p-0 text-center abs-center">
                                                <Row>
                                                    <Col lg={12}>
                                                        <TODIS_BTN_PRIMARY variant="primary" icon={MdDelete} sizeIcon="20" style={{ fontSize: "0px", padding: "0.4rem" }} onclick={() => props.onActionRemove(itm)} />
                                                    </Col>
                                                </Row>
                                            </Col>
                                        }
                                    </Row>
                                </Container>
                            </ListGroup.Item>
                        );
                    })}
                </ListGroup>
                <div className="todis-action-listForm">
                    <Button variant="primary" className="bck-btn-primary todis-submit-btn mt-2" onClick={props.onAction} ><props.iconButton className="me-3" size="18" />{props.labelButton}</Button>
                </div>
            </Row>
        </Container>
    </Form.Group>
}

const TODIS_FORM_LIST = (props) => {
    return <Form.Group className="mb-3">
        <Row>
            <Col lg={6}>
                <Form.Label style={{ ...input_org_styles_lable, width: "100%" }}>{props.name} </Form.Label>
            </Col>
            <Col lg={6}>
                <TODIS_FORM_FIELD_CHECK id="selectAll" label="SELECT ALL" selectAll={props.selectAll} disabled={props.disabled} />
            </Col>
        </Row>
        <Container className={"todis-form-wrapperR"}>
            <Row className="list-Items" style={{ minHeight: "0px", display: props.id == "transP" ? "inline-block" : "flex" }}>
                {props.items.map((itm) => {
                    return (
                        <ListGroup className="overflow-auto w-50" style={{ maxHeight: props.type != "added" ? "480px" : "520px", flexGrow: "1", display: "inline-flex" }} key={`check${itm.id}`} >
                            <Form.Check type="checkbox" id={itm.id} className="float-end" value={itm.id} style={{ paddingLeft: "45px", lineHeight: "35px" }} >
                                <Form.Check.Input type="checkbox" className="form-check-inputAll" checked={itm.status} style={{ border: "2px solid #ffc61c", fontSize: "25px" }} onChange={() => props.toggleSelectionAll(itm.id)} disabled={props.disabled} />
                                <Form.Check.Label className="font-monospace fw-bold" style={{ fontSize: "15px" }}>{itm.name}</Form.Check.Label>
                            </Form.Check>
                            {props.id == "transP" ?
                                itm.permissions && itm.permissions.map((item, index) =>
                                    <ListGroup className="overflow-auto" style={{ paddingLeft: "35px" }} key={index}>
                                        <Form.Check type="checkbox" id={item.id} className="float-end" key={`check${item.id}`} value={item.id} style={{ paddingLeft: "45px", lineHeight: "35px" }} disabled={props.disabled}>
                                            <Form.Check.Input type="checkbox" className="form-check-inputAll" checked={item.status} style={{ border: "2px solid #ffc61c", fontSize: "25px" }} onChange={() => props.toggleSelectionAll(itm, item)} disabled={props.disabled} />
                                            <Form.Check.Label className="font-monospace fw-bold" style={{ fontSize: "15px" }}>{item.name}</Form.Check.Label>
                                        </Form.Check>
                                    </ListGroup>
                                ) : null
                            }
                        </ListGroup>
                    );
                })}
            </Row>
        </Container>
    </Form.Group>
}

const TODIS_FORM_LIST_EUAcquis = (props) => {

    return <Form.Group className="mb-3">
        <Row>
            <Col lg={6}>
                <Form.Label style={{ ...input_org_styles_lable, width: "100%" }}>{props.name} </Form.Label>
            </Col>
        </Row>
        <Container className={"todis-form-wrapperR"}>
            <Row className="list-Items" style={{ minHeight: "0px" }}>
                {props.items.map((itm) => {
                    return (
                        <ListGroup className="overflow-auto w-50" style={{ maxHeight: props.type != "added" ? "480px" : "520px", flexGrow: "1", display: "inline-flex" }} key={`check${itm.id}`} >
                            <Form.Check type="checkbox" id={itm.id} className="float-end" value={itm.id} style={{ paddingLeft: "45px", lineHeight: "35px" }} >
                                <Form.Check.Input type="checkbox" className="form-check-inputAll" checked={itm.status} style={{ border: "2px solid #ffc61c", fontSize: "25px" }} onChange={() => props.toggleSelectionAll(itm.id)} disabled={props.disabled} />
                                <Form.Check.Label className="font-monospace fw-bold" style={{ fontSize: "15px" }}>{itm.name}</Form.Check.Label>
                            </Form.Check>
                            {props.id == "transP" ?
                                itm.permissions && itm.permissions.map((item, index) =>
                                    <ListGroup className="overflow-auto" style={{ paddingLeft: "35px" }} key={index}>
                                        <Form.Check type="checkbox" id={item.id} className="float-end" key={`check${item.id}`} value={item.id} style={{ paddingLeft: "45px", lineHeight: "35px" }} disabled={props.disabled}>
                                            <Form.Check.Input type="checkbox" className="form-check-inputAll" checked={item.status} style={{ border: "2px solid #ffc61c", fontSize: "25px" }} onChange={() => props.toggleSelectionAll(itm, item)} disabled={props.disabled} />
                                            <Form.Check.Label className="font-monospace fw-bold" style={{ fontSize: "15px" }}>{item.name}</Form.Check.Label>
                                        </Form.Check>
                                    </ListGroup>
                                ) : null
                            }
                        </ListGroup>
                    );
                })}
            </Row>
        </Container>
    </Form.Group>
}

const TODIS_FORM_FIELD_DATE = ({ editable, ...props }) => {
    const { setFieldValue } = useFormikContext();
    const [field] = useField(props);
    const isDataSharingPage = window.location.href.includes("/DataSharing");
    return (
        <Form.Group className={(props.notLabel === undefined || props.notLabel === "true") ? "mb-3" : ""} controlId={props.id}>
            {
                (props.notLabel === undefined || props.notLabel === "true") && (
                    <Form.Label style={input_org_styles_lable}>{props.label}</Form.Label>
                )
            }
            <DatePicker
                {...field}
                {...props}
                id={props.id}
                autoComplete="off"
                disabled={props.disabled}
                dateFormat="dd/MM/yyyy"
                className="form-control datepicker"
                placeholderText={!isDataSharingPage ? (field.placeholder || "Please select a date") : ""}
                style={input_org_styles}
                selected={(field.value && new Date(field.value)) || null}
                onChange={(val) => {
                    setFieldValue(field.name, dateFormat(val, "yyyy-mm-dd"));
                    if (props.isChange)
                        props.onchange(val);
                }}
            />
        </Form.Group>
    );
};

const TODIS_FORM_FIELD_DATE_YEAR = ({ ...props }) => {

    const [value, setValue] = useState(new Date())

    const onChange = (value) => {
        props.setFieldValue(props.name, value);
        console.log('value of the date', value);
    }

    return (
        <Form.Group className={"mb-3"} controlId={props.id}>
            {
                <Form.Label style={input_org_styles_lable}>{props.label}</Form.Label>
            }
            <DatePickerYear
                onlyYearPicker
                placeholder="Select"
                onChange={(date) => {
                    onChange(date?.isValid ? date : "");
                }}
                animations={[
                    opacity(),
                    transition({ from: 35, duration: 800 })
                ]}
                style={{
                    border: "0px",
                    width: "100%",
                    color: "#004494",
                    placeholder: (provided, state) => ({
                        ...provided,
                        color: "#004494"
                    })
                }}


                containerStyle={input_org_styles}
            />
        </Form.Group>
    );
};

const TODIS_FORM_FIELD_DATE_RQ = ({ ...props }) => {
    const { setFieldValue } = useFormikContext();
    const [field] = useField(props);
    return (
        <Form.Group className={(props.notLabel == undefined || props.notLabel == "true") ? "mb-3" : ""} controlId={props.id}>
            {
                props.notLabel == undefined || props.notLabel == "true" ? <Form.Label style={input_org_styles_lable}>{props.label}</Form.Label> : ''
            }
            <DatePicker
                {...field}
                {...props}
                autoComplete="off"
                disabled={props.disabled}
                dateFormat="dd/MM/yyyy"
                className="form-control datepicker"
                //minDate= {props.validateFrom ? props.validateFrom : null}
                placeholderText={field.placeholder || "Please select a date"}
                style={input_org_styles}
                selected={(field.value && new Date(field.value)) || null}
                onChange={(val) => {
                    setFieldValue(field.name, val);
                    if (props.isChange)
                        onchange(val);
                }
                }
            />
        </Form.Group>
    );
};

const TODIS_FORM_FIELD_GROUP = ({ id, type, placeholder, onChange, value }) => {
    return (
        <InputGroup style={type == "sharing" ? sec_styles_2 : sec_styles}>
            <BsSearch size="18" style={{ margin: "5px 0px" }} />
            <Form.Control
                id={id} type={type} placeholder={placeholder} onChange={onChange} value={value} style={type == "sharing" ? input_group_styles_2 : input_group_styles}
            />
        </InputGroup >
    )
};

const TODIS_FILTER = ({ placeholder, onFilter }) => {
    return (
        <InputGroup className="input-filter">
            <Form.Control
                placeholder={placeholder} className="control-filter" onKeyPress={onFilter}
            />
        </InputGroup >
    )
};

const TODIS_DROPDOWN = (props) => {
    return (
        <Dropdown as={ButtonGroup} align={{ lg: 'end' }} drop={props.drop} onSelect={props.handleSelect} style={{ width: "100%" }}>
            <Dropdown.Toggle
                id="dropdown-custom-1"
                classes="fw-bolder"
                style={{
                    backgroundColor: "#E3F2FD",
                    borderColor: "#E3F2FD",
                    fontSize: "11px",
                    color: "#004494",
                    padding: "0.7rem 1rem",
                    borderRadius: "12px",
                    letterSpacing: '1px',
                    textAlign: "left",
                    width: "100%"
                }}

            >{props.icon && <props.icon size="16" style={{ marginRight: "5px" }} />}{props.title}</Dropdown.Toggle>
            <Dropdown.Menu style={{ borderRadius: "0.5rem", border: "1px solid #cedae7" }}>
                {props.response ?
                    props.type == "country_code" ?
                        props.items.map((item, index) => {
                            return <Dropdown.Item key={index} eventKey={item.countryCode}>{item.txtDescription}</Dropdown.Item>
                        })
                        :
                        props.items.map((item, index) => {
                            return <Dropdown.Item key={index} eventKey={item.idAuxtabledetail ? item.idAuxtabledetail : item.id}>{item.txtDescription ? item.txtDescription : item.name}</Dropdown.Item>
                        })
                    : <Dropdown.Item >Loading...</Dropdown.Item>
                }
            </Dropdown.Menu>
        </Dropdown>
    )
};

const TODIS_DROPDOWN_REGIONAL = (props, notLabel = true, val) => {
    return (
        <Form.Group className="mb-3" controlId={props.id}>
            {notLabel && <Form.Label className="form-label" style={input_org_styles_lable}>{props.label}</Form.Label>}

            <Field
                id={props.id}
                name={props.name}
                style={props.type === "sharing" ? input_ddl_styles : input_org_styles}
                as="select"
                placeholder={props.holder}
                disabled={props.editable}
                value={val}
            >
                <option value="">{props.placeholder || ""}</option>
                {props.response ? (
                    props.type === "country_code" ? (
                        props.items.map((item, index) => (
                            <option key={index} value={item.txtDescription}>
                                {item.txtDescription}
                            </option>
                        ))
                    ) : (
                        props.items.map((item, index) => (
                            <option key={index} value={item.idAuxtabledetail ? item.idAuxtabledetail : item.id}>
                                {item.txtDescription ? item.txtDescription : item.name}
                            </option>
                        ))
                    )
                ) : (
                    <option value="" disabled>
                        Loading...
                    </option>
                )}
            </Field>
        </Form.Group>
    );
};

const TODIS_FORM_FIELD_MULTISELECT = ({ id, name, label, isLoading, options, setFieldValue, values, disabled }) => {

    const optionsComputed = [];
    const newValue = [];
    let arrayname = [];
    let newValor = values;

    if (options) {
        for (const data of Object.values(options))
            optionsComputed.push({ label: data.label ? data.label : data.name ? data.name?.toUpperCase() : data.txtDescription?.toUpperCase(), value: data.value ? data.value : data.id ? data.id : data.idAuxtabledetail ? data.idAuxtabledetail : data.roleName });
    }
    if (values[name]) {
        for (const data of Object.values(values[name]))
            newValue.push({ label: data.label ? data.label : data.name ? data.name?.toUpperCase() : data.txtDescription?.toUpperCase(), value: data.value ? data.value : data.id ? data.id : data.idAuxtabledetail ? data.idAuxtabledetail : data.roleId })
    } else {
        arrayname = String(name).split(".");

        arrayname.map(item => {
            newValor = newValor[item]
        });
        if (newValor != 0 && newValor != null) {
            for (const data of Object.values(newValor))
                newValue.push({ label: data.label ? data.label : data.name ? data.name?.toUpperCase() : data.txtDescription?.toUpperCase(), value: data.value ? data.value : data.id ? data.id : data.idAuxtabledetail ? data.idAuxtabledetail : data.roleId })
        }
    }

    const customStyles = {
        menu: (provided, state) => ({
            ...provided,
            zIndex: 1,
            float: 'revert',
            position: 'relative'
        }),
        control: (provided, state) => ({
            ...provided,
            borderRadius: "12px",
            marginTop: "0.5rem",
            border: "1px solid #e3f2fd"
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            padding: "0.2rem 1rem"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            color: "#004494"
        })
    }

    return <Form.Group className="mb-3" controlId={id}>
        <Form.Label className="form-label" style={input_org_styles_lable}>{label}</Form.Label>
        <Field
            name={name}
            render={({ field, form: { isSubmitting } }) => (
                <Select
                    {...field}
                    id={id}
                    styles={customStyles}
                    isMulti
                    isDisabled={disabled}
                    placeholder=""
                    isLoading={isLoading}
                    isClearable
                    options={optionsComputed}
                    value={newValue}
                    onChange={option => setFieldValue(name, option)}
                />
            )}
        />
    </Form.Group>
}

const TODIS_FORM_FIELD_MULTISELECT_FUEL = ({ id, name, label, isLoading, options, setFieldValue, values, disabled }) => {

    const optionsComputed = [];
    const newValue = [];
    let arrayname = [];
    let newValor = values;

    if (options) {
        for (const data of Object.values(options))
            optionsComputed.push({ label: data.label ? data.label : data.name ? data.name?.toUpperCase() : data.txtDescription?.toUpperCase(), value: data.value ? data.value : data.id ? data.id : data.idAuxtabledetail ? data.idAuxtabledetail : data.roleName });
    }
    if (values[name]) {
        for (const data of Object.values(values[name]))
            newValue.push({ label: data.label ? data.label : data.name ? data.name?.toUpperCase() : data.txtDescription?.toUpperCase(), value: data.value ? data.value : data.id ? data.id : data.idAuxtabledetail ? data.idAuxtabledetail : data.roleId })
    } else {
        arrayname = String(name).split(".");

        arrayname.map(item => {
            newValor = newValor[item]
        });
        if (newValor != 0 && newValor != null) {
            for (const data of Object.values(newValor))
                newValue.push({ label: data.label ? data.label : data.name ? data.name?.toUpperCase() : data.txtDescription?.toUpperCase(), value: data.value ? data.value : data.id ? data.id : data.idAuxtabledetail ? data.idAuxtabledetail : data.roleId })
        }
    }

    const fuelStationsDirA = values.roadsNpmInfraDTO.fuelStationsDirA || 0;
    const fuelStationsDirB = values.roadsNpmInfraDTO.fuelStationsDirB || 0;

    // Verificar si el número total de estaciones de combustible es 0
    const shouldDisable = fuelStationsDirA + fuelStationsDirB === 0;

    const customStyles = {
        menu: (provided, state) => ({
            ...provided,
            zIndex: 1,
            float: 'revert',
            position: 'relative'
        }),
        control: (provided, state) => ({
            ...provided,
            borderRadius: "12px",
            marginTop: "0.5rem",
            border: "1px solid #e3f2fd"
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            padding: "0.2rem 1rem"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            color: "#004494"
        })
    };

    return (
        <Form.Group className="mb-3" controlId={id}>
            <Form.Label className="form-label" style={input_org_styles_lable}>{label}</Form.Label>
            <Field
                name={name}
                render={({ field, form: { isSubmitting } }) => (
                    <Select
                        {...field}
                        id={id}
                        styles={customStyles}
                        isMulti
                        isDisabled={disabled || shouldDisable}
                        placeholder="Select"
                        isLoading={isLoading}
                        isClearable
                        options={optionsComputed}
                        value={newValue}
                        onChange={option => setFieldValue(name, option)}
                    />
                )}
            />
        </Form.Group>
    );
};




export { TODIS_FORM_FIELD_OTHER, TODIS_FORM_FIELD_OPTIONS_ITS, TODIS_FORM_FIELD_OPTIONS_WITHOUT_CHANGE_1, TODIS_FORM_FIELD_OPTIONS, TODIS_FORM_FIELD_MULTISELECT_FUEL, TODIS_FORM_FIELD_MOD, TODIS_DROPDOWN_REGIONAL, TODIS_FORM_FIELD_DROP, TODIS_FORM_FIELD_ROUTE, TODIS_FORM_FIELD_INFRA, TODIS_FORM_LIST_EUAcquis, TODIS_FORM_FIELD_OPTIONS_WITHOUT_CHANGE_ID, TODIS_FORM_TEXT, TODIS_FORM_PASS, TODIS_FORM_ORG, TODIS_FORM_DSC, TODIS_FORM_FIELD_GROUP, TODIS_FILTER, TODIS_FORM_FIELD,TODIS_FORM_FIELD_NUMBER, TODIS_FORM_FIELD_YES_NO, TODIS_FORM_FIELD_OPTIONS_WITH_CHANGE, TODIS_FORM_FIELD_OPTIONS_WITHOUT_CHANGE, TODIS_FORM_FIELD_OPTIONS_DESC, TODIS_FORM_FIELD_CHECK, TODIS_FORM_FIELD_LIST, TODIS_FORM_FIELD_DATE, TODIS_FORM_FIELD_TEXT, TODIS_FORM_FIELD_TEXT_FORM, TODIS_FORM_FIELD_PASS, TODIS_FORM_FIELD_OPTIONS_SL, TODIS_FORM_FILE, TODIS_DROPDOWN, TODIS_FORM_LIST, TODIS_FORM_FIELD_DATE_RQ, TODIS_FORM_FIELD_OPTIONS_GDB, TODIS_FORM_FIELD_MULTISELECT, TODIS_FORM_FIELD_DATE_YEAR, TODIS_FORM_FIELD_TABLE };

const text_styles = {
    borderRadius: '19px',
    padding: '1rem',
    marginTop: '2rem',
    border: '0px',
    color: '#0B4CA150'
}

const input_org_styles = {
    borderRadius: '12px',
    padding: '0.5rem 1rem',
    marginTop: '0.5rem',
    border: '1px solid #E3F2FD',
    width: "100%",
    color: "#004494"
}

const input_desc_styles = {
    borderRadius: '12px',
    padding: '0.5rem 1rem',
    marginTop: '0.5rem',
    border: '1px solid #e3f2fd',
    width: "100%",
    height: "200px",
    color: "#004494"
}

const input_group_styles = {
    borderRadius: '12px',
    padding: '0.5rem 1rem',
    border: '0px',
    height: '31px',
    backgroundColor: '#e3f2fd'
}

const input_group_styles_2 = {
    borderRadius: '12px',
    padding: '0.5rem 1.0rem',
    border: '0px',
    height: '31px',
    backgroundColor: "white",
}

const input_org_styles_lable = {
    color: '#004494',
    fontSize: "14px",
    fontWeight: "bold"
}

const label_style = {
    color: "rgb(51 116 192)",
    fontSize: "9px",
    fontWeight: "bold",
    width: "100%"
}

const sec_styles = {
    backgroundColor: "#E3F2FD",
    fontSize: "14px",
    color: "#004494",
    borderColor: "#E3F2FD",
    padding: "0.5rem 1rem",
    borderRadius: "12px",
    letterSpacing: '1px',
    width: "100%",
    textAlign: "left"
}

const sec_styles_2 = {
    backgroundColor: "white",
    fontSize: "14px",
    color: "#004494",
    borderColor: "#E3F2FD",
    padding: '0.2rem 0.5rem',
    borderRadius: "12px",
    letterSpacing: '1px',
    width: "100%",
    textAlign: "left",
    marginTop: "0.5rem",
    border: '1px solid #00449440'
}

const input_ddl_styles = {
    backgroundColor: "#E3F2FD",
    borderRadius: '12px',
    padding: '0.5rem 1rem',
    marginTop: '0.5rem',
    border: '1px solid #00449440',
    width: "100%",
    color: 'rgb(0, 68, 148)',
    fontSize: "14px",
    fontWeight: "bold"
}
